import React, { useState, useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import { Table, Button, Spinner } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import SVG from "react-inlinesvg";
import toast from "react-hot-toast";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import * as Yup from "yup";
import { baseUrl } from "../../services/config";
import { toAbsoluteUrl } from "../../_metronic/_helpers";

const AppUpdateMessages = () => {
  const [addLoading, setaddLoading] = useState(false);
  const [loading, setloading] = useState(false);
  const authToken = localStorage.getItem("userToken");
  const [deleteLoading, setdeleteLoading] = useState(false);
  const [selectedObject, setselectedObject] = useState(null);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [editModal, seteditModal] = useState(false);
  const [messagesList, setmessagesList] = useState([]);

  const handleClose = () => {
    setShow(false);
    formik.resetForm();
  };
  const handleShow = () => {
    // Check if we already have messages for both types
    const traditionalExists = messagesList.some(
      (msg) => msg.type && msg.type.id === 1
    );
    const foldableExists = messagesList.some(
      (msg) => msg.type && msg.type.id === 2
    );

    if (traditionalExists && foldableExists) {
      toast.error("You can only add one message per type (TRADITIONAL and FOLDABLE)");
      return;
    }
    setShow(true);
  };

  const handleClose2 = () => setShow2(false);
  const handleShow2 = (id) => {
    setselectedObject(id);
    setShow2(true);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const initialValues = {
    title: "",
    description: "",
    type: "",
  };

  const LoginSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
    type: Yup.string()
      .required("Type is required")
      .oneOf(["1", "2"], "Type must be either TRADITIONAL (1) or FOLDABLE (2)"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setaddLoading(true);

      // Check if message of this type already exists
      const typeExists = messagesList.some(
        (msg) => msg.type && msg.type.id === parseInt(values.type)
      );

      if (typeExists) {
        toast.error(
          `A message for type ${
            values.type === "1" ? "TRADITIONAL" : "FOLDABLE"
          } already exists. You can only have one message per type.`
        );
        setaddLoading(false);
        setSubmitting(false);
        return;
      }

      const data = {
        title: values.title,
        description: values.description,
        type: parseInt(values.type),
      };

      fetch(`${baseUrl}/admin/app-update-messages`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(data),
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          return res.json();
        })
        .then((data) => {
          if (data.metadata && data.metadata.success) {
            toast.success(data.metadata.message || "Message added successfully");
            setSubmitting(false);
            getMessages();
            setaddLoading(false);
            handleClose();
          } else {
            const errorMessage = data.metadata?.message || "Failed to add message";
            if (typeof errorMessage === "object") {
              Object.values(errorMessage).forEach((msg) => {
                toast.error(msg);
              });
            } else {
              toast.error(errorMessage);
            }
            setaddLoading(false);
            setSubmitting(false);
          }
        })
        .catch((err) => {
          setSubmitting(false);
          setaddLoading(false);
          console.error("add message error", err);
          // Only show error if it's not a network error
          if (err.message && !err.message.includes("HTTP error")) {
            toast.error("An error occurred while adding the message");
          }
        });
    },
  });

  const editFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: selectedObject?.title || "",
      description: selectedObject?.description || "",
      type: selectedObject?.type?.id?.toString() || "",
    },
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setaddLoading(true);

      // Check if another message of this type already exists (excluding current one)
      const typeExists = messagesList.some(
        (msg) =>
          msg.id !== selectedObject.id &&
          msg.type &&
          msg.type.id === parseInt(values.type)
      );

      if (typeExists) {
        toast.error(
          `A message for type ${
            values.type === "1" ? "TRADITIONAL" : "FOLDABLE"
          } already exists. You can only have one message per type.`
        );
        setaddLoading(false);
        setSubmitting(false);
        return;
      }

      const data = {
        title: values.title,
        description: values.description,
        type: parseInt(values.type),
      };

      fetch(
        `${baseUrl}/admin/app-update-messages/${selectedObject?.id}?_method=PUT`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify(data),
        }
      )
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          return res.json();
        })
        .then((responseData) => {
          // Check for new response structure (data object) or old structure (metadata.success)
          if (responseData.data || (responseData.metadata && responseData.metadata.success)) {
            toast.success(responseData.metadata?.message || "Message updated successfully");
            setSubmitting(false);
            getMessages();
            setaddLoading(false);
            seteditModal(false);
            setselectedObject(null);
          } else {
            const errorMessage = responseData.metadata?.message || "Failed to update message";
            if (typeof errorMessage === "object") {
              Object.values(errorMessage).forEach((msg) => {
                toast.error(msg);
              });
            } else {
              toast.error(errorMessage);
            }
            setaddLoading(false);
            setSubmitting(false);
          }
        })
        .catch((err) => {
          setSubmitting(false);
          setaddLoading(false);
          console.error("update message error", err);
          toast.error("An error occurred while updating the message");
        });
    },
  });

  useEffect(() => {
    getMessages();
  }, []);

  const getMessages = () => {
    setloading(true);
    fetch(`${baseUrl}/admin/app-update-messages`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        if (data.metadata && data.metadata.success) {
          setmessagesList(data.payload || []);
        } else {
          setmessagesList([]);
        }
        setloading(false);
      })
      .catch((err) => {
        setloading(false);
        console.error("messages error", err);
        toast.error("An error occurred while fetching messages");
      });
  };

  const deleteMessage = () => {
    setdeleteLoading(true);
    fetch(`${baseUrl}/admin/app-update-messages/${selectedObject}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => {
        // Check if status is successful (200-299)
        if (res.ok) {
          // Success - no response body, just 200 status
          handleClose2();
          getMessages();
          setdeleteLoading(false);
          toast.success("Message deleted successfully");
        } else {
          // Error status code
          throw new Error(`HTTP error! status: ${res.status}`);
        }
      })
      .catch((err) => {
        console.error("delete error", err);
        setdeleteLoading(false);
        toast.error("An error occurred while deleting the message");
      });
  };

  const editMessage = (item) => {
    setselectedObject(item);
    seteditModal(true);
  };

  const handleCloseEdit = () => {
    seteditModal(false);
    setselectedObject(null);
    editFormik.resetForm();
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <Button className="mr-2 mb-2" variant="primary" onClick={handleShow}>
          Add New
        </Button>
      </div>

      <Paper style={{ padding: "20px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <h3>App Update Messages</h3>
        </div>

        <hr style={{ marginLeft: "-20px", marginRight: "-20px" }} />

        {loading ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "50px",
            }}
          >
            <Spinner animation="border" />
          </div>
        ) : (
          <Table responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Title</th>
                <th>Description</th>
                <th>Type</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {messagesList && messagesList.length > 0 ? (
                messagesList.map((item, index) => (
                  <tr key={item.id}>
                    <td style={{ verticalAlign: "center" }}>{index + 1}</td>
                    <td style={{ verticalAlign: "center" }}>{item.title}</td>
                    <td style={{ verticalAlign: "center" }}>
                      {item.description}
                    </td>
                    <td style={{ verticalAlign: "center" }}>
                      {item.type?.name || "N/A"}
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <a
                          className="btn btn-icon btn-light btn-sm"
                          onClick={() => editMessage(item)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-primary">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/General/Edit.svg"
                              )}
                            />
                          </span>
                        </a>
                        <a
                          className="btn btn-icon btn-light btn-sm"
                          onClick={() => handleShow2(item.id)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-danger">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/General/Trash.svg"
                              )}
                            />
                          </span>
                        </a>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    No messages found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </Paper>

      {/* Add Modal */}
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add App Update Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework"
          >
            <div className="row">
              <div className="col-md-12 mb-3">
                <label>Title</label>
                <input
                  type="text"
                  name="title"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "title"
                  )}`}
                  placeholder="Enter title"
                  {...formik.getFieldProps("title")}
                />
                {formik.touched.title && formik.errors.title ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.title}</div>
                  </div>
                ) : null}
              </div>

              <div className="col-md-12 mb-3">
                <label>Description</label>
                <textarea
                  name="description"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "description"
                  )}`}
                  placeholder="Enter description"
                  rows="4"
                  {...formik.getFieldProps("description")}
                />
                {formik.touched.description && formik.errors.description ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.description}
                    </div>
                  </div>
                ) : null}
              </div>

              <div className="col-md-12 mb-3">
                <label>Type</label>
                <select
                  name="type"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "type"
                  )}`}
                  {...formik.getFieldProps("type")}
                >
                  <option value="">Select Type</option>
                  {!messagesList.some((msg) => msg.type && msg.type.id === 1) && (
                    <option value="1">TRADITIONAL</option>
                  )}
                  {!messagesList.some((msg) => msg.type && msg.type.id === 2) && (
                    <option value="2">FOLDABLE</option>
                  )}
                </select>
                {formik.touched.type && formik.errors.type ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.type}</div>
                  </div>
                ) : null}
                {messagesList.some((msg) => msg.type && msg.type.id === 1) &&
                  messagesList.some((msg) => msg.type && msg.type.id === 2) && (
                    <div className="fv-plugins-message-container mt-2">
                      <div className="fv-help-block text-warning">
                        Both types already have messages. You can only have one
                        message per type.
                      </div>
                    </div>
                  )}
              </div>
            </div>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button
                variant="primary"
                type="submit"
                disabled={addLoading}
              >
                {addLoading ? "Saving..." : "Save"}
              </Button>
            </Modal.Footer>
          </form>
        </Modal.Body>
      </Modal>

      {/* Edit Modal */}
      <Modal size="lg" show={editModal} onHide={handleCloseEdit}>
        <Modal.Header closeButton>
          <Modal.Title>Edit App Update Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={editFormik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework"
          >
            <div className="row">
              <div className="col-md-12 mb-3">
                <label>Title</label>
                <input
                  type="text"
                  name="title"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${
                    editFormik.touched.title && editFormik.errors.title
                      ? "is-invalid"
                      : editFormik.touched.title && !editFormik.errors.title
                      ? "is-valid"
                      : ""
                  }`}
                  placeholder="Enter title"
                  {...editFormik.getFieldProps("title")}
                />
                {editFormik.touched.title && editFormik.errors.title ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {editFormik.errors.title}
                    </div>
                  </div>
                ) : null}
              </div>

              <div className="col-md-12 mb-3">
                <label>Description</label>
                <textarea
                  name="description"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${
                    editFormik.touched.description && editFormik.errors.description
                      ? "is-invalid"
                      : editFormik.touched.description &&
                        !editFormik.errors.description
                      ? "is-valid"
                      : ""
                  }`}
                  placeholder="Enter description"
                  rows="4"
                  {...editFormik.getFieldProps("description")}
                />
                {editFormik.touched.description &&
                editFormik.errors.description ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {editFormik.errors.description}
                    </div>
                  </div>
                ) : null}
              </div>

              <div className="col-md-12 mb-3">
                <label>Type</label>
                <select
                  name="type"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${
                    editFormik.touched.type && editFormik.errors.type
                      ? "is-invalid"
                      : editFormik.touched.type && !editFormik.errors.type
                      ? "is-valid"
                      : ""
                  }`}
                  {...editFormik.getFieldProps("type")}
                >
                  <option value="">Select Type</option>
                  <option value="1">TRADITIONAL</option>
                  <option value="2">FOLDABLE</option>
                </select>
                {editFormik.touched.type && editFormik.errors.type ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{editFormik.errors.type}</div>
                  </div>
                ) : null}
              </div>
            </div>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseEdit}>
                Close
              </Button>
              <Button variant="primary" type="submit" disabled={addLoading}>
                {addLoading ? "Updating..." : "Update"}
              </Button>
            </Modal.Footer>
          </form>
        </Modal.Body>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal show={show2} onHide={handleClose2}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this message?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose2}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={deleteMessage}
            disabled={deleteLoading}
          >
            {deleteLoading ? "Deleting..." : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AppUpdateMessages;

